import { api } from '@/lib/api'
import type { LoginInput, LoginResponse, SessionUser } from '@sophia/shared-schemas'

export async function login(input: LoginInput): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', input)
  return data
}

export async function fetchMe(): Promise<SessionUser> {
  const { data } = await api.get<SessionUser>('/auth/me')
  return data
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}
